// Unpublished Work © 2022 Deere & Company

import t from 'tcomb';

export const customerProfileStatus = {
    ACTIVE: 'A',
    INACTIVE: 'IN'
};

export const CustomerProfileStatus = t.enums.of(Object.values(customerProfileStatus), 'CustomerProfileStatus');
